module.exports = __webpack_public_path__ + "media/images/patient-icons/radio-icon-7afde5956c013e1ad79ee1ccfb04720f.svg";